import { gql } from 'apollo-angular';

export const PURCHASE_ORDERS = gql`
  query purchaseOrders($input: PurchaseOrderPaginationInput) {
    purchaseOrders(input: $input) {
      purchaseOrders {
        id
        vendorId
        vendor {
          vendorName
        }
        customerId
        customer {
          firstName
          lastName
        }
        purchaseOrderNo
        reference
        dueDate
        billDate
        customerNote
        status
        purchaseStatus
        purchaseUrl
        totalAmount
        subTotal
        tax
        discount
        # purchaseItems
        currencyId
        # currencyData
        branchId
        # branchData
        bills {
          billStatus
        }
        exchangeRate
        isApproved
        approvedBy
        approver {
          firstName
          lastName
        }
      }
      total
      skip
      limit
    }
  }
`;
export const PURCHASE_ORDER = gql`
  query purchaseOrder($id: Int!) {
    purchaseOrder(id: $id) {
      id
      vendorId
      vendor {
        id
        vendorName
        trn
        email
        phone
        address
      }
      customerId
      customer {
        id
        firstName
        lastName
      }
      purchaseOrderNo
      reference
      dueDate
      billDate
      customerNote
      status
      purchaseStatus
      purchaseUrl
      subTotal
      discount
      tax
      totalAmount
      purchaseItems {
        id
        purchaseOrderId
        itemName
        description
        quantity
        rate
        subTotal
        tax
        totalAmount
      }
      currencyId
      currencyData {
        id
        currencyCode
        currencyName
      }
      branchId
      exchangeRate
      isApproved
      approvedBy
      approver {
        id
        firstName
        lastName
      }
    }
  }
`;
